import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { orderByValues } from '@/metrics/hooks/useFilters/constants'

import TableHeaderButton from '../TableHeaderButton/TableHeaderButton'
import { tableTitle } from './constants'
import * as Styles from './styles'

const ProductTypeTableHeader = ({ type, salesOrdersDataActivated, orderBy, onSort, rateLabel }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const isGroupBySelected = (currentFilter, selectedFilter) => {
    const currentFilterWithoutOrdering = currentFilter?.replace('-', '')

    return currentFilterWithoutOrdering === selectedFilter
  }

  const isClickable = () => {
    return salesOrdersDataActivated && typeof onSort === 'function'
  }

  const handleSort = value => {
    if (isClickable()) {
      onSort(value)
    }
  }

  const getRateLabel = () => {
    if (!salesOrdersDataActivated) return '%'

    return rateLabel || t('Tasa devoluciones')
  }

  const getDirection = () => {
    if (salesOrdersDataActivated) {
      return orderBy?.startsWith('-') ? 'desc' : 'asc'
    }
  }

  return (
    <Styles.Container>
      <div>
        <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }} color={theme.colors.text.subtle}>
          {t(tableTitle[type])}
        </Text>
      </div>
      <Styles.TotalsContainer>
        {salesOrdersDataActivated && (
          <TableHeaderButton
            onClick={() => handleSort(orderByValues.sales)}
            selected={isGroupBySelected(orderBy, orderByValues.sales)}
            direction={getDirection()}
            disabled={!isClickable()}
          >
            <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
              {t('Unidades vendidas')}
            </Text>
          </TableHeaderButton>
        )}
        <TableHeaderButton
          onClick={() => handleSort(orderByValues.returns)}
          selected={isGroupBySelected(orderBy, orderByValues.returns)}
          direction={getDirection()}
          disabled={!isClickable()}
        >
          <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
            {t('Unidades devueltas')}
          </Text>
        </TableHeaderButton>
        <TableHeaderButton
          onClick={() => handleSort(orderByValues.ratio)}
          selected={isGroupBySelected(orderBy, orderByValues.ratio)}
          direction={getDirection()}
          disabled={!isClickable()}
        >
          <Text
            type="allCapsS"
            customStyles={{
              textTransform: 'uppercase',
              width: '56px',
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {getRateLabel()}
          </Text>
        </TableHeaderButton>
      </Styles.TotalsContainer>
    </Styles.Container>
  )
}

export default ProductTypeTableHeader
